import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

const CryptoJS = require('crypto-js');
Vue.use(Vuex);
/* eslint-disable */

const state = {
  infomation: {
    brand: localStorage.getItem('brand'),
  },
  imCart: [],
  shopCart: [],
  itemList: [],
  item: {
    title: '',
    en_title: '',
    item_price: '',
    size: '',
    iceSelect: '',
    sugarSelect: '',
    num: 1,
  },
  info: {
    token: '',
    phone: '',
    birth: '',
    name: '',
  },
  shopNo: '' || localStorage.getItem('shopNo')
}
const getters = {
  infomation: state => state.infomation,
  itemList: state => state.itemList,
  imCart: state => state.imCart,
  shopCart: state => state.shopCart,
  item: state => state.item,
  // info: state => state.info,
  verifyCode: state => state.verifyCode,
  register: state => state.register,
  shopNo: state => state.shopNo,
  storeInfo: state => state.storeInfo,
  returnCode: state => state.returnCode
}
const actions = {
  // 查詢會員
  checkUser({ commit, store }, contents) {
    var key = "XHOJaT4QqkvlsmjfuLhPlOInD9NiVCv1"
    var iv = "N6lRbzhhbyHgiU66"
    var keyStr = CryptoJS.enc.Utf8.parse(key)
    var ivStr = CryptoJS.enc.Utf8.parse(iv)
    // var nowtime = Date.now()
    // var content = `{"timestamp": ${nowtime}}`
    const apiUrl = 'https://ruentex-api-server.eilis-ai.com/api/test/checkUserByToken';
    const options = {
      iv: ivStr,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    };
    const content = JSON.stringify({
      service: contents.service,
      clientId: contents.clientId,
      token: contents.token,
    });
    const signature = CryptoJS.AES.encrypt(content, keyStr, options).toString()
    const data = {
      content: signature,
      // accessToken: contents.access,
    };
    // console.log(signature);
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'api-key': '175e0506314052a7d2a45ae20f6b0d257720b5f5',
      }
    }
    return axios.post(apiUrl, data, config)
      .then((res) => {
        return res;
      });
    },
}
const mutations = {
  updatebrand (state, { brand }) {
    state.infomation.brand = brand
  },
  storeItem(state, list ) {
    // console.log(list);
    state.itemList = list.data
  },
  updatetoken (state, { token }) {
    state.info.token = token
  },
  updatename (state, { name }) {
    state.info.name = name
  },
  updatebirth (state, { birth }) {
    state.info.birth = birth
  },
  // 購物車
  updateNum (state, { num }) {
    state.item.num = num
  },
  updateTitle (state, { title }) {
    state.item.title = title
  },
  updateEn_title (state, { en_title }) {
    state.item.en_title = en_title
  },
  updatePrice (state, { item_price }) {
    state.item.item_price = item_price
  },
  updateSize (state, { size }) {
    state.item.size = size
  },
  updateIce (state, { iceSelect }) {
    state.item.iceSelect = iceSelect
  },
  updateSugar (state, { sugarSelect }) {
    state.item.sugarSelect = sugarSelect
  },
  updateShopCart (state, { shopCart }) {
    console.log(shopCart);
    state.shopCart = shopCart
    // console.log(shopCart);
  },
  updateImCart(state, { imCart }) {
    state.imCart = imCart
    // console.log(shopCart);
  }
}
export default {
    state,
    getters,
    actions,
    mutations
}